const LanguageManager = require('../modules/language_manager/language_manager').default;
module.exports = {
    getMPAARatingByAge: function(age) {
        const country = localStorage.getItem('LGI_CCountry') || 'IN';

        let ageKey = `age_screen_${age}_${country}`;
        if (!country) {
            ageKey = `age_screen_${age}`;
        }

        const value = LanguageManager.get(ageKey);
        if (value === ageKey) {
            ageKey = `age_screen_${age}`;
        }
        return LanguageManager.get(ageKey);
    }
};



// WEBPACK FOOTER //
// ./src/util/age_rating.js